import _ from "lodash";

export const getGroupedJackpotByName = (data, name) => {
  const items = data?.filter(j => j.jackpotName === name) || [];
  if (items.length === 0) return null;

  return {
    name,
    totalAmount: _.sumBy(items, 'amount'),
    currencyId: items[0].currencyId,
    spinningRounding: items[0].spinningRounding,
    winningRounding: items[0].winningRounding,
    rawData: items
  };
};
